import { Row } from "antd";
import { useMediaQuery } from "react-responsive";
import { useNavigate } from "react-router-dom";
import useDarkMode from "../../hooks/useDarkMode";
import { SingleAppCardDesktop } from "./SingleAppCardDesktop";
import { SingleAppCardMobile } from "./SingleAppCardMobile";

const CategoryAppList = ({ apps }) => {
    const navigate = useNavigate();
    const [darkMode] = useDarkMode();
    const isLargeScreen = useMediaQuery({
        query: "(min-width: 990px)",
    });

    const handleClick = (app) => {
        const app_id = app.value;
        navigate(`/pro/create-app/${app_id}`);
    };

    return (
        <div>
            {apps.map((app) => {
                return (
                    <Row
                        style={{
                            marginTop: "10px",
                            display: "flex",
                            background: darkMode ? "#0000004a" : "#F5F5F5",
                            borderRadius: "10px",
                        }}>
                        {isLargeScreen ? (
                            <SingleAppCardDesktop app={app} handleClick={handleClick} />
                        ) : (
                            <SingleAppCardMobile app={app} handleClick={handleClick} />
                        )}
                    </Row>
                );
            })}
        </div>
    );
};

export { CategoryAppList };
